import moment from "moment";

export interface Row {
	dateStartsUTC: string;
	dateEndsJustBeforeUTC: string;
	privateMessageDatesentUTC?: string;
}

export function convertEventDatesToJavascriptDates<T extends Row>(row: T) {
	const {
		dateStartsUTC,
		dateEndsJustBeforeUTC,
		privateMessageDatesentUTC,
		...rest
	} = row;

	return {
		...rest,
		dateStartsUTC: moment.utc(dateStartsUTC).toDate(),
		dateEndsJustBeforeUTC: moment.utc(dateEndsJustBeforeUTC).toDate(),
		...(privateMessageDatesentUTC
			? {
					privateMessageDatesentUTC: moment
						.utc(privateMessageDatesentUTC)
						.toDate()
			  }
			: {})
	};
}
